const data = {
  vowels: {
    title: `Vowels (svara)`,
    titleSanskrit: `स्वर`,
    characters: [
      { length: "short", complexity: "simple", en: "a", sa: "अ" },
      { length: "short", complexity: "simple", en: "i", sa: "इ" },
      { length: "short", complexity: "simple", en: "u", sa: "उ" },
      { length: "short", complexity: "simple", en: "ṛ", sa: "ऋ" },
      {
        length: "short",
        complexity: "simple",
        en: "ḷ",
        sa: "ऌ",
        uncommon: true,
      },
      { length: "long", complexity: "simple", en: "ā", sa: "आ" },
      { length: "long", complexity: "simple", en: "ī", sa: "ई" },
      { length: "long", complexity: "simple", en: "ū", sa: "ऊ" },
      {
        length: "long",
        complexity: "simple",
        en: "ṝ",
        sa: "ॠ",
        uncommon: true,
      },
      { length: "short", complexity: "complex", en: "e", sa: "ए" },
      { length: "short", complexity: "complex", en: "o", sa: "ओ" },
      { length: "long", complexity: "complex", en: "ai", sa: "ऐ" },
      { length: "long", complexity: "complex", en: "au", sa: "औ" },
    ],
  },
  consonants: {
    title: `Consonants (vyañjana)`,
    titleSanskrit: `व्यञ्जन`,
    characters: [
      {
        type: "stop",
        class: "gutteral",
        voiced: "unvoiced",
        aspirated: "unaspirated",
        en: "ka",
        sa: "क",
      },
      {
        type: "stop",
        class: "gutteral",
        voiced: "unvoiced",
        aspirated: "aspirated",
        en: "kha",
        sa: "ख",
      },
      {
        type: "stop",
        class: "gutteral",
        voiced: "voiced",
        aspirated: "unaspirated",
        en: "ga",
        sa: "ग",
      },
      {
        type: "stop",
        class: "gutteral",
        voiced: "voiced",
        aspirated: "aspirated",
        en: "gha",
        sa: "घ",
      },
      {
        type: "stop",
        class: "palatal",
        voiced: "unvoiced",
        aspirated: "unaspirated",
        en: "ca",
        sa: "च",
      },
      {
        type: "stop",
        class: "palatal",
        voiced: "unvoiced",
        aspirated: "aspirated",
        en: "cha",
        sa: "छ",
      },
      {
        type: "stop",
        class: "palatal",
        voiced: "voiced",
        aspirated: "unaspirated",
        en: "ja",
        sa: "ज",
      },
      {
        type: "stop",
        class: "palatal",
        voiced: "voiced",
        aspirated: "aspirated",
        en: "jha",
        sa: "झ",
      },
      {
        type: "stop",
        class: "retroflex",
        voiced: "unvoiced",
        aspirated: "unaspirated",
        en: "ṭa",
        sa: "ट",
      },
      {
        type: "stop",
        class: "retroflex",
        voiced: "unvoiced",
        aspirated: "aspirated",
        en: "ṭha",
        sa: "ठ",
      },
      {
        type: "stop",
        class: "retroflex",
        voiced: "voiced",
        aspirated: "unaspirated",
        en: "ḍa",
        sa: "ड",
      },
      {
        type: "stop",
        class: "retroflex",
        voiced: "voiced",
        aspirated: "aspirated",
        en: "ḍha",
        sa: "ढ",
      },
      {
        type: "stop",
        class: "dental",
        voiced: "unvoiced",
        aspirated: "unaspirated",
        en: "ta",
        sa: "त",
      },
      {
        type: "stop",
        class: "dental",
        voiced: "unvoiced",
        aspirated: "aspirated",
        en: "tha",
        sa: "थ",
      },
      {
        type: "stop",
        class: "dental",
        voiced: "voiced",
        aspirated: "unaspirated",
        en: "da",
        sa: "द",
      },
      {
        type: "stop",
        class: "dental",
        voiced: "voiced",
        aspirated: "aspirated",
        en: "dha",
        sa: "ध",
      },
      {
        type: "stop",
        class: "labial",
        voiced: "unvoiced",
        aspirated: "unaspirated",
        en: "pa",
        sa: "प",
      },
      {
        type: "stop",
        class: "labial",
        voiced: "unvoiced",
        aspirated: "aspirated",
        en: "pha",
        sa: "फ",
      },
      {
        type: "stop",
        class: "labial",
        voiced: "voiced",
        aspirated: "unaspirated",
        en: "ba",
        sa: "ब",
      },
      {
        type: "stop",
        class: "labial",
        voiced: "voiced",
        aspirated: "aspirated",
        en: "bha",
        sa: "भ",
      },
      {
        type: "nasal",
        aspirated: null,
        class: "gutteral",
        voiced: "voiced",
        en: "ṅa",
        sa: "ङ",
      },
      {
        type: "nasal",
        aspirated: null,
        class: "palatal",
        voiced: "voiced",
        en: "ña",
        sa: "ञ",
      },
      {
        type: "nasal",
        aspirated: null,
        class: "retroflex",
        voiced: "voiced",
        en: "ṇa",
        sa: "ण",
      },
      {
        type: "nasal",
        aspirated: null,
        class: "dental",
        voiced: "voiced",
        en: "na",
        sa: "न",
      },
      {
        type: "nasal",
        aspirated: null,
        class: "labial",
        voiced: "voiced",
        en: "ma",
        sa: "म",
      },
      {
        type: "semivowel",
        aspirated: null,

        class: "palatal",
        voiced: "voiced",
        en: "ya",
        sa: "य",
      },
      {
        type: "semivowel",
        aspirated: null,

        class: "retroflex",
        voiced: "voiced",
        en: "ra",
        sa: "र",
      },
      {
        type: "semivowel",
        aspirated: null,

        class: "dental",
        voiced: "voiced",
        en: "la",
        sa: "ल",
      },
      {
        type: "semivowel",
        aspirated: null,

        class: "labial",
        voiced: "voiced",
        en: "va",
        sa: "व",
      },
      {
        type: "sibilant",
        aspirated: null,
        class: "gutteral",
        voiced: "unvoiced",
        en: "ha",
        sa: "ह",
      },
      {
        type: "sibilant",
        aspirated: null,
        class: "palatal",
        voiced: "unvoiced",
        en: "śa",
        sa: "श",
      },
      {
        type: "sibilant",
        aspirated: null,
        class: "retroflex",
        voiced: "unvoiced",
        en: "ṣa",
        sa: "ष",
      },
      {
        type: "sibilant",
        aspirated: null,
        class: "dental",
        voiced: "unvoiced",
        en: "sa",
        sa: "स",
      },
    ],
  },
  additionalCharacters: {
    title: `Additional characters`,
    characters: [
      { en: "anusvāra", sa: "ं" },
      { en: "visarga", sa: "ः" },
      { en: "daṇḍa", sa: "।" },
      { en: "virāma", sa: "◌्" },
    ],
  },
  specialConjuncts: {
    title: `Special conjuncts`,
    characters: [
      { en: "kṣa", sa: "क्ष" },
      { en: "jña", sa: "ज्ञ" },
      { en: "śca", sa: "श्च" },
      { en: "śra", sa: "श्र" },
      { en: "śva", sa: "श्व" },
    ],
  },
};

export default data;
